/* BY BOOST — animations légères : apparition au défilement, blocs flottants, survols. Respecte « réduire les animations ». */
(function(){
var d=document, root=d.documentElement;
if(!d.querySelector('.bb')) return;
var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
root.classList.add('bb-js');
if(reduce){ root.classList.add('bb-reduce'); return; }
var sel=[
'.bb .bb-intro','.bb .bb-hero__grid > *','.bb .bb-split > *','.bb .bb-founder > *',
'.bb .bb-steps > li','.bb .bb-pains > div','.bb .bb-also > a','.bb .bb-reviews > *',
'.bb .bb-box','.bb .bb-faq details','.bb .bb-table-wrap','.bb .bb-paths > *',
'.bb .bbh-situ','.bb .bbh-bloc','.bb .bbh-coeur','.bb .bbh-plan','.bb .bbh-ps-ligne','.bb .bbh-offre','.bb .bbh-final',
'.bb .bbva__node','.bb .bbva__hub','.bb .bbvc__res','.bb .bbn__card','.bb .bbmt__card',
'.bb .bbo-work > div','.bb .bbo-plat article','.bb .bbo-cond li','.bb .bbo-scope > div','.bb .bbo-ba figure',
'.bb .bbx-sec .mk','.bb .bbx-pts li','.bb .bbm-card'
].join(',');
var els=[].slice.call(d.querySelectorAll(sel));
els.forEach(function(el){
var sib=el.parentElement?[].slice.call(el.parentElement.children).filter(function(c){return c.matches(sel);}):[el];
var i=Math.max(0,sib.indexOf(el));
el.classList.add('bb-rv');
el.style.transitionDelay=Math.min(i,6)*70+'ms';
});
if('IntersectionObserver' in window){
var io=new IntersectionObserver(function(entries){
entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('bb-in'); io.unobserve(e.target); } });
},{rootMargin:'0px 0px -8% 0px',threshold:0.08});
els.forEach(function(el){ io.observe(el); });
} else { els.forEach(function(el){ el.classList.add('bb-in'); }); }
/* Blocs flottants dans le haut de page : léger effet de profondeur à la souris */
var hero=d.querySelector('.bb .bb-hero');
if(hero && window.matchMedia('(hover:hover)').matches){
hero.addEventListener('mousemove',function(ev){
var r=hero.getBoundingClientRect();
var x=(ev.clientX-r.left)/r.width-.5, y=(ev.clientY-r.top)/r.height-.5;
hero.style.setProperty('--px',(x*14).toFixed(1)+'px');
hero.style.setProperty('--py',(y*10).toFixed(1)+'px');
});
hero.addEventListener('mouseleave',function(){ hero.style.setProperty('--px','0px'); hero.style.setProperty('--py','0px'); });
}
})();